<template>
  <div class="invite-list" :class="language">
    <div class="invite-list-title"></div>
    <div class="rank-list my-rank-list" v-if="myRanks.length">
      <div class="my-rank-wrap">
        <div
          class="week-rank-item"
          v-for="(mRank, mIndex) in myRanks"
          :key="mIndex"
        >
          <img class="avatar" :src="mRank.headUrl" />
          <div class="name text-ellipsis">{{ mRank.name }}</div>
          <div class="time">
            <span>{{ mRank.successTime }}</span>
          </div>
        </div>
      </div>
      <div class="total">总收益：{{ totalReward }}金豆</div>
    </div>
    <div class="rank-list my-rank-empty" v-else>
      <img class="empty-icon" src="~@/assets/pic_kzht@2x.png" />
      <div class="empty-text">
        {{ $t('暂无邀请的好友，快去邀请吧') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    language: {
      type: String,
      default: 'zh'
    },
    myRanks: {
      type: Array,
      default: () => []
    },
    totalReward: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      active: 0,
      tabs: ['ھەپتىلىك تىزىملىك', 'مېنىڭ تەكلىپىم'],
      tabZhs: ['邀请周榜', '我的邀请']
      // weekRanks: [],
      // myRanks: [],
      // totalReward: 0
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.invite-list {
  width: 339px;
  height: 425px;
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #beef95;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  color: #fd9822;
  font-size: 14px;

  .invite-list-title {
    width: 237px;
    height: 38px;
    margin: auto;
    @include bg-image('newInvite/pic_wdyq@3x');
  }
  .rank-list {
    flex: 1;
    box-sizing: border-box;
    padding: 20px 16px 48px;
    position: relative;
    overflow: hidden;
    .my-rank-wrap {
      height: 100%;
      overflow: auto;
    }
    .week-rank-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      &:last-child {
        border: none;
      }
      .name {
        width: 145px;
        font-weight: 500;
      }
    }
    .avatar {
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .total {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 20px;
      text-align: center;
    }
    .week-rank-item {
      overflow: hidden;
      &:nth-last-child(2) {
        border: none;
      }
    }
    .time {
      flex: 1;
      text-align: right;
      span {
        width: 200%;
        display: inline-block;
        font-size: 20px;
        transform: scale(0.5);
        transform-origin: left;
      }
    }
  }
  .my-rank-empty {
    padding-top: 100px;
    text-align: center;
    .empty-icon {
      display: inline-block;
      width: 120px;
      height: 107px;
      margin-bottom: 8px;
    }
    .empty-text {
      max-width: 275px;
      margin: auto;
    }
  }
}
</style>
